import React from "react";
import Button from '@material-ui/core/Button';
import { connectAssessmentSessionData } from '../../containers/application/channelDashboard/redux_actions'
let server = "https://us-central1-coaching-platform-illumine.cloudfunctions.net/serverResponse";

function startSession({ sessionId, instanceId, uid, assessmentTestId, manageToolData }) {
  let requestOptions = {
    method: 'POST',
    body: JSON.stringify({ sessionId, instanceId, uid, assessmentTestId }),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };

  fetch(`${server}/classSession`, requestOptions)
    .catch(err => {
      console.log(err)
    }).then(response => {
      response
        .json()
        .then(response => {
          if (!response.success) {
          } else {
            let { assessmentSessionId, assessmentTestId, otp } = response.msg;
            manageToolData({ toolId: assessmentTestId, content: { assessmentSessionId, otp } })
            connectAssessmentSessionData(assessmentSessionId)
          }

          // sessionId: "1597059249250"
          // uid: "qIvQM3g3HUawWctvzI0zzcqqsHk1"
          // otp: "VONE"
          // assessmentTestId: "a001"
          // assessmentSessionId: "-MF_PECd4LHeK53a66nZ"

        });
    });
}

export default ({ sessionId, instanceId, uid, assessmentTestId, engagementData, manageToolData }) => {
  let assessmentSessionId = engagementData[assessmentTestId] && engagementData[assessmentTestId].assessmentSessionId
    ? engagementData[assessmentTestId].assessmentSessionId : null;
  return <div style={{
    background: '#F2F2F2', width: '100%', height: '100%',
    padding: '0px 32px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around'
  }}>
    <div style={{ padding: 16, background: '#FFF', borderRadius: 16, maxWidth: 490 }}>
      <div style={{ fontWeight: '500', fontSize: 20 }}>Participants take the Pre-Session Assessment</div>
      {engagementData[assessmentTestId] && engagementData[assessmentTestId].otp
        ? <div>{engagementData[assessmentTestId].otp}</div>
        : <div>ASD</div>}

      <Button
        variant="contained"
        onClick={(e) => { startSession({ sessionId, instanceId, uid, assessmentTestId, manageToolData }) }}
      >
        {engagementData[assessmentTestId] && engagementData[assessmentTestId].otp ? 'Restart Session' : 'Start Session'}
      </Button>
    </div>
    <div style={{ padding: 16, background: '#FFF', borderRadius: 16 }}>
      {Object.keys(engagementData[assessmentSessionId] && engagementData[assessmentSessionId].participants
        ? engagementData[assessmentSessionId].participants
        : {}).map(pid => {
          let a = engagementData[assessmentSessionId].participants[pid]
          return <div key={pid}>{a.name}</div>
        })}
    </div>
  </div>
}